/**
 * RESPONSIBILITY: turn the hero's pictures into the slides to draw, and say how each one moves.
 *
 * NO MOVEMENT IS CHOSEN. Every large picture takes its turn through a rotation - zoom in, pan
 * left, zoom out, pan right - stepping on with every scene, so neighbours never move the same
 * way and nobody has to decide. The rotation is the site's, not a setting.
 */
import { hasImage, type ImageValue } from '@framework/core';

export interface Slide {
  image: ImageValue;
}

const CYCLE = ['zoom-in', 'pan-left', 'zoom-out', 'pan-right'];

/** Which movement a full-width photograph gets, by the scene it is in. */
export const autoMotion = (sceneId: number, place: number) => CYCLE[(sceneId + place) % CYCLE.length];

/** The pictures that are actually there, in the order given. */
export const slidesOf = (images: (ImageValue | undefined)[]): Slide[] =>
  images.filter(hasImage).map((image) => ({ image }));
